import React from 'react';
import Helmet from 'react-helmet';
import GlobalStyle from '../../GlobalStyles';

const TemplateWrapper = ({ children }) => {
    const minHeight = { minHeight: '100vh' };
    const isBrowser = typeof window !== "undefined";
    let shouldLoadProduction = false;

    if (isBrowser && window.location.href.indexOf("motivosity-sandbox") === -1 && process.env.NODE_ENV === 'production') {
        shouldLoadProduction = true;
    }

    return (
        <>
            <Helmet>
                <html lang="en" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
                <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,300;1,700&display=swap" rel="stylesheet"></link>
                <meta
                    http-equiv="Content-Type"
                    content="text/html; charset=utf-8"
                />
                <meta http-equiv="X-UA-Compatible" content="IE=edge" />

                {/* Only add newrelic for production*/}
                {shouldLoadProduction ? 
                    <script type="text/javascript">
                        {`
                            ;window.NREUM||(NREUM={});
                            NREUM.init = {
                                distributed_tracing: { enabled: true },
                                privacy: { cookies_enabled: true },
                                ajax: { deny_list: ["bam.nr-data.net"] }
                            };
                            NREUM.loader_config = {
                                accountID: "815436",
                                trustKey: "815436",
                                agentID: "601407245",
                                licenseKey: "80dfe6fe9f",
                                applicationID: "601407245"
                            };
                            NREUM.info = {
                                beacon: "bam.nr-data.net",
                                errorBeacon: "bam.nr-data.net",
                                licenseKey: "80dfe6fe9f",
                                applicationID: "601407245",
                                sa: 1
                            };
                        `}
                    </script>
                : null }

                {shouldLoadProduction ?
                    <script
                        type="text/javascript"
                        src="https://js-agent.newrelic.com/nr-loader-spa-1.244.0.min.js"
                    ></script>
                : null } 
                
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0"
                />

                <meta name="theme-color" content="#fff" />
                <meta property="og:type" content="Motivosity" />

                <meta
                    name="facebook-domain-verification"
                    content="juelu9vnyg1xl6dv1kvst8ceyv8bec"
                />

                <link
                    rel="image_src"
                    href="https://www.motivosity.com/static/a8152546986b82260bb3c1f1c88125a8/60782/logo-wordmark-black.webp"
                />

                <meta
                    name="google-site-verification"
                    content="XO4qJ7Nur3E4Nv0wknNfsxL5De6_1pH0164mt_kSZaM"
                />
                
                {/* Adding a noindex tag to every page in the staging env */}
                {isBrowser && window.location.href.indexOf("motivosity-sandbox") !== -1 ? 
                    <meta name="robots" content="noindex" /> 
                : null
                }
            </Helmet>
            <GlobalStyle />

            {children}
        </>
    );
};

export default TemplateWrapper;
